export const FEEDBACK_CREATE_MODAL_KEY = 'feedback-create';
export const SEARCH_MODAL_KEY = 'search-modal';
